import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import Seo from "@/components/Seo";
import { FAQ_ITEMS } from "@/data/content";

const Faq = () => {
  return (
    <div data-testid="faq-page" className="bg-cream">
      <Seo
        title="FAQ — UNSTUCK Activity Decks, UNSTUCK Bucks & Ordering"
        description="Answers about UNSTUCK senior activity cards: the 4 ways to play, UNSTUCK Bucks rewards, assisted living and caregiver use, bulk orders, and what comes in each program."
        path="/faq"
      />
      <div className="max-w-4xl mx-auto px-6 sm:px-8 lg:px-12 py-16 sm:py-24">
        <div className="mb-14">
          <p className="text-sm uppercase tracking-widest font-semibold text-gold-dark mb-4">Questions, answered</p>
          <h1 className="font-heading font-black text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-tight text-ink mb-6">
            Frequently asked questions
          </h1>
          <p className="text-lg sm:text-xl leading-relaxed text-ink/80">
            Everything about UNSTUCK, the Seniors program, UNSTUCK Bucks, and ordering.
          </p>
        </div>
        <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
          {FAQ_ITEMS.map((item, i) => (
            <AccordionItem key={item.q} value={`item-${i}`} className="border-b border-border py-2">
              <AccordionTrigger
                data-testid={`faq-question-${i}`}
                className="text-left font-heading font-bold text-xl text-ink hover:text-sage hover:no-underline py-5"
              >
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-lg leading-relaxed text-ink/80 pb-6">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  );
};

export default Faq;
